/**
 * Ad Placements Registry
 * 
 * Single source of truth for all supported ad placement locations.
 * Each placement defines where ads can appear in the application.
 * 
 * IMPORTANT: Only placements defined here are considered "wired" and will
 * actually render ads. Custom placements in DB but not here show a warning.
 */

export const AD_PLACEMENTS = [
  {
    key: "tech_dashboard_sidebar",
    label: "Tech Dashboard Sidebar",
    description: "Shown on the technician dashboard sidebar",
    surface: "technician",
    dimensions: { width: 300, height: "auto" },
  },
  {
    key: "contractor_dashboard_sidebar",
    label: "Contractor Dashboard Sidebar", 
    description: "Shown on the contractor/owner dashboard sidebar",
    surface: "contractor",
    dimensions: { width: 300, height: "auto" },
  },
  {
    key: "contractor_main_bottom",
    label: "Contractor Main Bottom",
    description: "Shown at the bottom of contractor main content area (Dashboard + management pages)",
    surface: "contractor",
    dimensions: { width: "full", height: "auto" },
  },
  {
    key: "settings_sidebar",
    label: "Settings Sidebar",
    description: "Shown on contractor settings pages sidebar/footer",
    surface: "contractor",
    dimensions: { width: 300, height: "auto" },
  },
  {
    key: "job_list_banner",
    label: "Job List Banner",
    description: "Banner at top of job list page",
    surface: "contractor",
    dimensions: { width: "full", height: 90 },
  },
  {
    key: "calendar_sidebar",
    label: "Calendar Sidebar",
    description: "Shown on calendar page sidebar",
    surface: "contractor",
    dimensions: { width: 280, height: "auto" },
  },
];

// Map for quick lookup by key
export const AD_PLACEMENTS_MAP = AD_PLACEMENTS.reduce((acc, placement) => {
  acc[placement.key] = placement;
  return acc;
}, {});

// Get all placement keys
export const AD_PLACEMENT_KEYS = AD_PLACEMENTS.map(p => p.key);

// Check if a placement key is wired (exists in registry)
export const isPlacementWired = (key) => AD_PLACEMENT_KEYS.includes(key);

// Get placement by key
export const getPlacement = (key) => AD_PLACEMENTS_MAP[key] || null;

export default AD_PLACEMENTS;
